<template>
  <div id="position-table-pl">
    <template
      v-if="
        position.ticker !== user.baseCurrency &&
        !position.pendingRecreate &&
        position.totalValueBaseCurrency &&
        (isDaily || position.totalCostWithComissionBaseCurrency)
      "
    >
      <div class="items-flex position-table-pl-value">
        <template v-if="type === 'net'">
          <TableNetPercent
            v-if="!isDaily"
            :value="position.plBaseCurrency"
            :currency="user.baseCurrency"
            type="net"
          />
          <TableNetPercent
            v-else-if="isDaily && position.dailyPlBaseCurrency"
            :value="position.dailyPlBaseCurrency"
            :currency="user.baseCurrency"
            type="net"
          />
          <span v-else></span>
        </template>
        <template v-else-if="type === 'percent'">
          <TableNetPercent v-if="!isDaily" :value="position.plBaseCurrencyPercent" type="percent" />
          <TableNetPercent
            v-else-if="position.dailyPlBaseCurrency"
            :value="position.dailyPlBaseCurrencyPercent"
            type="percent"
          />
          <span v-else></span>
        </template>
      </div>
    </template>
    <span v-else></span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Currency from '@/views/components/common/Currency.vue'
import TableNetPercent from '@/views/components/common/TableNetPercent'

export default {
  components: { Currency, TableNetPercent },
  props: {
    position: {
      type: Object,
      default: () => {},
    },
    isDaily: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'net',
    },
  },
  computed: {
    ...mapState(['user']),
  },
}
</script>

<style lang="scss">
#position-table-pl {
  .items-flex {
    display: flex;
  }
}
</style>
